import React from "react";
import { Input } from "antd";
import "./index.scss";

// What the organization tells our team about the plan it needs, sent with its
// Enterprise request (enterpriseRequest.js). Optional: our team gets in touch
// either way.
function EnterpriseNeedsField({ value, onChange, label = "Tell us what you need", id = "enterprise-needs" }) {
   return (
      <div className="enterprise-needs-field">
         {label && <label htmlFor={id}>{label}</label>}
         <Input.TextArea
            id={id}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            placeholder="How many workspaces, the projects in each and the users in each, monthly or annual billing, and anything else you need."
            autoSize={{ minRows: 4, maxRows: 10 }}
            maxLength={2000}
         />
      </div>
   );
}

export default EnterpriseNeedsField;
